import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="wrapper">
          <h1>"Ready to Change Your Life? <br />
            Your Millionaire Adventure Begins Here!"
          </h1>

          <h2>Don’t wait any longer! Start your millionaire adventure today <br />
and unlock the life you’ve always dreamed of. Your future self will thank you!
          </h2>

          <div className='video_wrapper'>
            <iframe
              src="https://player.vimeo.com/video/1144391208"
              title="Vimeo video player"
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                border: 0,
              }}
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          </div>
      </div>

      <div className='messageme_btn_wrapper'>
          <button
            type="button"
            onClick={() => window.open("https://www.facebook.com/workwithkrizia/", "_blank", "noopener,noreferrer")}
          >
            I AM READY! MESSAGE ME HOW TO START
        </button>
      </div>

      <div className='footer_wrapper'>
          <div className='left'>
              Copyright - All Rights Reserved 2025  
          </div>
          <div className='right'>
              Queen Boss Society
          </div>
      </div>
    </div>
  );
}

export default App;
